import React from "react";

export const DotLoader = () => {
  return (
    <div className="dot-loader login-loader-progress loading-span">
      <style>{`
        @keyframes loadingAnimation {
          0%,
          75%,
          100% {
            transform: scale(1.5);
            opacity: 0;
          }
          25%,
          50% {
            transform: scale(1);
            opacity: 1;
          }
        }
        .dot-loader.login-loader-progress {
          display: inline-flex;
          width: max-content;
          gap: 20px;
          justify-content: center;
          align-items: center;
        }
        .dot-loader.login-loader-progress span {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
          border-radius: 50%;
          display: inline-block;
          margin: 15px 0;
          background: rgba(0, 0, 0, 0.2);
          position: relative;
          color: rgba(0, 0, 0, 0.2);
        }
        .dot-loader.loading-span span::after {
          position: absolute;
          top: 0;
          left: 0;
          background: var(--primary-color-first, var(--primary-theme-color, #EC6687));
          opacity: 1;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          transform: scale(1.5);
          animation: loadingAnimation 3s infinite both;
          content: "";
        }
        .dot-loader.loading-span span:nth-child(1)::after {
          animation-delay: 0.1s;
        }
        .dot-loader.loading-span span:nth-child(2)::after {
          animation-delay: 0.2s;
        }
        .dot-loader.loading-span span:nth-child(3)::after {
          animation-delay: 0.3s;
        }
      `}</style>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default DotLoader;
